import { useQuery } from "@tanstack/react-query";
import type { Category } from "@arc/contracts";
import type { AuthSession } from "../../auth/keycloak.js";
import { categoryApi } from "../../api/client.js";

/**
 * The caller's realm-wide categories (ADR-007) — the attach picker for the facility create/edit drawer. Keyed by tenant
 * + subject like `useFacilities`. Realm-visible (RLS-scoped server-side); no per-node gate.
 */
export function useCategories(session: AuthSession | null) {
  return useQuery({
    queryKey: ["categories", session?.realm, session?.sub],
    enabled: session !== null,
    queryFn: async (): Promise<Category[]> => {
      const res = await categoryApi.listCategories();
      if (res.status !== 200) throw new Error(`GET /categories returned ${res.status}`);
      return res.body.categories;
    },
  });
}
